import React from "react";
import styles from "../Carousel.module.css";

const { carouselHeader, headerArrows } = styles;

export const Header = ({
  title,
  children,
  lockedNext,
  lockedPrev,
}: {
  title?: string;
  children?: React.ReactNode;
  lockedNext?: boolean;
  lockedPrev?: boolean;
}) => {
  return (
    <div className={carouselHeader}>
      {title && <h2>{title}</h2>}
      <div
        className={headerArrows}
        data-locked-next={lockedNext}
        data-locked-prev={lockedPrev}
        role="group"
        aria-label="Carousel navigation arrows"
      >
        {children}
      </div>
    </div>
  );
};
